import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import {Button, Form, message, Select, Space, Tag} from "antd";
import {Link} from "react-router-dom";
import * as api from "../../apis/salesOrder";
import {
    LogType,
    PaymentStatusOptions, PlatformType,
    SalesOrderStatusEnum,
    SalesOrderStatusMapping,
    SalesOrderStatusOptions
} from "../../utils/constants";
import DictSelect from "../../components/DictSelect";
import CategoryCascader from "../../components/CategoryCascader";
import * as categoryApi from "../../apis/productCategory";
import {useRequest} from "ahooks";
import {Fragment, useState} from "react";
import dayjs from "dayjs";
import BaseDataSelect from "../../components/BaseDataSelect";
import LogModal from "../../components/LogModal";
import Divider from "../../components/Divider";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import withAuth from "../../utils/withAuth";
import OrderContactModal from "../../components/OrderContactModal";
import useQueryParam from "../../utils/useQueryParam";

const ContactButton = withAuth('contact', Button);
const ExportOrderButton = withAuth('exportOrder', Button);
const ExportOrderLinesButton = withAuth('exportOrderLines', Button);

function SalesOrder(props: any) {
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const [categories, setCategories] = useState([]);
    const [contactOrder, setContactOrder] = useState<number | string>();
    useQueryParam(params => {
        const {status = null} = params;
        if (params.thisWeekNew != null) params.thisWeekNew = parseInt(params.thisWeekNew)
        if (status) {
            form.setFieldsValue({'status': [parseInt(status)]});
        } else if (params.thisWeekNew) {
            form.setFieldsValue({...params, 'status': []})
        }
    });

    const {tableProps, refresh, form, search, download, downloading} = useAntTable(api.getSalesOrder, {
        method: "post",
        downloadUrl: api.exportOrderUrl
    });

    const {loading: loadingCategory} = useRequest(categoryApi.getCategoriesDict, {
        manual: false,
        onSuccess(res) {
            setCategories(res.data.data);
        }
    });
    const {loading: loadingContact, run: runContact} = useRequest(api.contactOrder, {
        manual: true,
        onSuccess(res) {
            setContactOrder(undefined);
            refresh();
        }
    })


    const columns: StandardColumnsType = [
        {
            dataIndex: 'code',
            key: 'code',
            title: '订单编号',
            width: 150,
            fixed: "left"
        },
        {
            dataIndex: 'dealerCode',
            key: 'dealerCode',
            title: '客户编号',
            width: 100,
        },
        {
            dataIndex: 'dealerName',
            key: 'dealerName',
            title: '客户名称',
            width: 100,
        },
        {
            dataIndex: 'groupName',
            key: 'groupName',
            title: '集团',
            width: 100
        },
        {
            dataIndex: 'categoryName',
            key: 'categoryName',
            title: '产品线',
            width: 100
        },
        {
            dataIndex: 'hospitalFullName',
            key: 'hospitalFullName',
            title: '终端医院',
            width: 200
        },
        {
            dataIndex: 'sourceOrderNumber',
            key: 'sourceOrderNumber',
            title: '来源单号',
            width: 200,
        },
        {
            dataIndex: 'associateNum',
            key: 'associateNum',
            title: '关联单号',
            width: 200,
        },
        {
            dataIndex: 'orderDate',
            key: 'orderDate',
            title: '订单日期',
            render(v) {
                return dayjs(v)?.format('ll');
            },
            width: 140
        },
        {
            dataIndex: 'status',
            key: 'status',
            title: '状态',
            render(v) {
                return SalesOrderStatusMapping[v];
            },
            width: 100
        },
        {
            dataIndex: 'productTotalAmount',
            key: 'productTotalAmount',
            title: '订单合计',
            width: 100
        },
        {
            dataIndex: 'paid',
            key: 'paid',
            title: '已付款',
            width: 100
        },
        {
            dataIndex: 'overtimePeriod',
            key: 'overtimePeriod',
            title: '超账期',
            render(v) {
                return v ? '是' : '否';
            },
            width: 100
        },
        {
            dataIndex: 'orderType',
            key: 'orderType',
            title: '订单类型',
            width: 100
        },
        {
            dataIndex: 'rebates',
            key: 'rebates',
            title: '返利订单',
            render(v) {
                return !!v ? '是' : '否'
            },
            width: 100
        },
        {
            dataIndex: 'contacted',
            key: 'contacted',
            title: '已联系',
            render(v) {
                return !!v ? '是' : '否'
            },
            width: 100
        },
        {
            dataIndex: 'oaPending',
            key: 'oaPending',
            title: 'OA送审状态',
            render(v, record: any) {
                return record.flowId === null ? <Tag color={"green"}>未送审</Tag> : <Tag color={'orange'}>正在送审</Tag>
            },
            width: 100,
            fixed: "right"
        },
        {
            dataIndex: 'operation',
            key: 'operation',
            title: '操作',
            render(_, record: any) {
                return <Divider>
                    <Link to={`/order/sales/detail/${record.id}`}>详情</Link>
                    {platform === PlatformType.Admin && <Button type={"link"}
                                                                onClick={() => LogModal.open(LogType.SalesOrder, record.id)}>日志</Button>}
                    <ContactButton type={"link"} onClick={() => handleContact(record)}>联系</ContactButton>
                </Divider>
            },
            width: 140,
            fixed: "right"
        }
    ];
    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'status',
            search: {
                valueRender: <Form form={form}>
                    <Form.Item labelCol={{span: 2}} label={'状态'} name={'status'}>
                        <Select mode={"tags"} options={SalesOrderStatusOptions}
                                fieldNames={{value: 'value', label: 'text'}}/>
                    </Form.Item>
                </Form>,
                valueInitial: platform === PlatformType.Admin ? [SalesOrderStatusEnum.NOT_SUBMITTED, SalesOrderStatusEnum.OVERDUE_PENDING, SalesOrderStatusEnum.BUSINESS_PENDING, SalesOrderStatusEnum.PAYMENT_PENDING]
                    : [SalesOrderStatusEnum.NOT_SUBMITTED, SalesOrderStatusEnum.OVERDUE_PENDING, SalesOrderStatusEnum.BUSINESS_PENDING, SalesOrderStatusEnum.PAYMENT_PENDING, SalesOrderStatusEnum.DELIVERY_PENDING, SalesOrderStatusEnum.PART_DELIVERY, SalesOrderStatusEnum.DELIVERED, SalesOrderStatusEnum.RECEIVED,]
                ,
                colSpan: 18
            }
        },
        {
            dataIndex: 'code',
            title: '订单编号',
            search: true
        },
        {
            dataIndex: 'dealer',
            title: '客户编码/名称',
            search: true
        },
        {
            dataIndex: 'group',
            title: '集团',
            search: {
                valueRender: <BaseDataSelect name={'groups'} nullLabel={'请选择'}/>
            }
        },
        {
            dataIndex: 'contractCode',
            title: '合同编号',
            search: true
        },
        {
            dataIndex: 'productCode',
            title: '商品编号',
            search: true
        },
        {
            dataIndex: 'hospitalFullName',
            title: '终端医院全称',
            search: true
        },
        {
            dataIndex: 'paymentStatus',
            title: '付款状态',
            search: {
                valueType: 'select',
                valueEnum: PaymentStatusOptions
            }
        },
        {
            dataIndex: 'oaPending',
            title: 'OA审核中',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: true, text: '是'},
                    {value: false, text: '否'},
                ]
            }
        },
        {
            dataIndex: 'orderDateRange',
            title: '订单日期',
            search: {
                valueType: 'dateRange'
            }
        },
        {
            dataIndex: 'orderType',
            title: '订单类型',
            search: {
                valueRender: <BaseDataSelect name={'orderTypes'} nullLabel={'请选择'}/>
            }
        },
        {
            dataIndex: 'businessMan',
            title: '商务人员姓名',
            search: true
        },
        {
            dataIndex: 'productCategory',
            title: '产品线',
            search: {
                valueRender: (<CategoryCascader options={categories} changeOnSelect
                                                fieldNames={{label: "name", children: "children", value: "id"}}/>)
            }
        },
        {
            dataIndex: 'timeoutPeriod',
            title: '是否超期',
            search: {
                valueType: 'check'
            }
        },
        {
            dataIndex: 'rebateOrder',
            title: '是否返利订单',
            search: {
                valueType: 'check'
            }
        },
        {
            dataIndex: 'thisWeekNew',
            key: 'thisWeekNew',
            title: '本周新增',
            search: {
                valueType: 'check',
            }
        },
        {
            dataIndex: 'scope',
            key: 'scope',
            title: '是否整单复制',
            search: {
                valueType: 'check'
            }
        },
        {
            dataIndex: 'sourceOrderNumber',
            key: 'sourceOrderNumber',
            title: '来源单号',
            search: true
        },
        {
            dataIndex: 'associateNum',
            key: 'associateNum',
            title: '关联单号',
            search: true
        }
    ];

    const handleContact = (record: any) => {
        setContactOrder(record.id);
    }

    const finishContact = (values: any) => {
        runContact(values);
    }

    const handleExportOrder = () => {
        download({type: 'head'});
    }
    const handleExportOrderLines = () => {
        download({type: 'line'});
    }

    const toolbar = (
        <Space>
            <Button type={'primary'} onClick={handleExportOrder} loading={downloading}>订单列表导出</Button>
            <Button type={'primary'} onClick={handleExportOrderLines} loading={downloading}>订单明细导出</Button>
        </Space>
    );

    return <PageHeaderLayout>
        <Form form={form}>
            <Form.Item noStyle name={'thisWeekNew'}/>
        </Form>
        <StandardTable columns={columns} extSearchColumns={searchColumns} {...tableProps} form={form} search={search}
                       scroll={{x: '100%'}} toolbar={toolbar}/>
        <OrderContactModal contactOrderId={contactOrder} onCancel={() => setContactOrder(undefined)}
                           onComplete={finishContact} destroyOnClose confirmLoading={loadingContact}/>
    </PageHeaderLayout>
}

export default SalesOrder;
